// statsStore.js — importierte Praxis-Statistiken (z.B. Umsatz je Monat).
//
// LIVE-Modus:  Supabase-Tabelle public.stats, ein Datensatz pro (typ, periode),
//              Re-Import aktualisiert (Upsert).
// DEMO-Modus:  localStorage "dida_stats" mit gleicher Struktur.
import { supabase } from "./supabase";
import { serverActive } from "./mode";

const KEY = "dida_stats";

const loadLocal = () => { try { const s = localStorage.getItem(KEY); if (s) return JSON.parse(s); } catch {} return []; };
const saveLocal = (rows) => { try { localStorage.setItem(KEY, JSON.stringify(rows)); } catch {} };

export async function listStats(typ) {
  if (!serverActive()) {
    return loadLocal().filter(r => !typ || r.typ === typ);
  }
  let q = supabase.from("stats").select("*").order("periode");
  if (typ) q = q.eq("typ", typ);
  const { data, error } = await q;
  if (error) throw error;
  return data;
}

// rows: [{typ, periode, payload, quelle}] — aktualisiert bestehende Perioden
export async function upsertStats(rows) {
  if (!serverActive()) {
    const existing = loadLocal();
    rows.forEach(r => {
      const i = existing.findIndex(x => x.typ === r.typ && x.periode === r.periode);
      if (i >= 0) existing[i] = { ...existing[i], ...r, updated_at: new Date().toISOString() };
      else existing.push({ ...r, id: Date.now() + Math.random(), updated_at: new Date().toISOString() });
    });
    saveLocal(existing);
    return { updated: rows.length };
  }
  const { error } = await supabase.from("stats").upsert(
    rows.map(r => ({ typ: r.typ, periode: r.periode, payload: r.payload, quelle: r.quelle || "" })),
    { onConflict: "typ,periode" }
  );
  if (error) throw error;
  return { updated: rows.length };
}
